var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33317 12.3333L0.166504 11.1666L4.83317 6.49996L0.166504 1.83329L1.33317 0.666626L5.99984 5.33329L10.6665 0.666626L11.8332 1.83329L7.1665 6.49996L11.8332 11.1666L10.6665 12.3333L5.99984 7.66663L1.33317 12.3333Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesIcon);
export default __webpack_public_path__ + "static/media/times-icon.b6b4e3330d46ce6a29e7e4750a08d828.svg";
export { ForwardRef as ReactComponent };